// i18next-extract-mark-ns-start LaRubrique
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Link } from '../../services/link';
import { tabletThresholdPixels, colors } from '../home/v4/styledComponents';
import coutureIcon from '../../assets/ourServices/couture.icon.services.svg';
import cordoIcon from '../../assets/ourServices/cordo.icon.services.svg';
import maroIcon from '../../assets/ourServices/maro.icon.services.svg';
import broderieIcon from '../../assets/ourServices/couturier/broderies.svg';
import joinTheCycle from '../../assets/ourServices/jointhecycle.services.svg';

type Icon = {
  [key: string]: string;
};
const icon: Icon = {
  couture: coutureIcon,
  leathergood: cordoIcon,
  shoemaker: maroIcon,
  embroidery: broderieIcon,
  jointhecycle: joinTheCycle,
};

const NavBar = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  margin: 0px auto;
  width: 1166px;
  min-height: 96px;


  @media (max-width: ${tabletThresholdPixels}) {
    width: 100%;
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 0px;
  }
`;

const NavBarBackground = styled.div`
  padding: 32px 0px;
  margin-bottom: 60px;
  @media (max-width: ${tabletThresholdPixels}) {
    margin-bottom: 0;
    margin-top: 20px;
  }
`;

const NavItem = styled(Link)`
  display: inline;
  margin: 0px 23.5px;
  cursor: pointer;
  color: ${colors.black};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 105%;
  text-transform: uppercase;
  display: inline-block;
  text-align:center;
  text-decoration: none;

  @media (max-width: ${tabletThresholdPixels}) {
    margin-bottom: 10px;
  }
` as typeof Link;

interface NavItemTextProps {
    isSelected: boolean;
}
const NavItemText = styled.div<NavItemTextProps>`
  ${({ isSelected }) => isSelected ? `
    font-weight: 700;
  ` : 'opacity: 0.5;'}

`;

interface NavImgProps {
    isSelected: boolean;
}
const NavImg = styled.img<NavImgProps>`
  width: 40px;
  height: 40px;
  margin-bottom: 10px;
  ${({ isSelected }) => !isSelected && `
    opacity: 0.5;
  `}
`;
type MainCategory = {
  slug: string;
  name: string;
  path: string;
};
function BlogNavbar({ mainCategories, mainCategory }: { mainCategories: MainCategory[], mainCategory: MainCategory }) {
  const { t } = useTranslation();
  return (
    <NavBarBackground>
      <NavBar>
        {mainCategories.map(({ slug, name, path }) => (
          <NavItem
            key={slug}
            to={`${path}1`}
            placeholder=''
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          >
            <NavImg isSelected={mainCategory?.name === name} src={icon[slug]} alt={name} />
            <NavItemText isSelected={mainCategory?.name === name}>{t(name)}</NavItemText>
          </NavItem>
        ))}
      </NavBar>
    </NavBarBackground>
  );
}

export default BlogNavbar;
